<template>
	<div :style="{direction: $vs.rtl ? 'rtl' : 'ltr'}">
		<feather-icon
			icon="Edit2Icon"
			svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
			class="g-label--normal"
			@click="editRecord"
		/>
		<feather-icon
			v-if="resourceDeletePermission"
			icon="Trash2Icon"
			svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
			class="g-label--normal"
			@click="confirmDeleteRecord"
		/>
	</div>
</template>

<script>
import moduleResource from "@/store/resource/moduleResource.js";

export default {
	name: "CellRendererActions",
	computed: {
		resourceDeletePermission() {
			return this.$store.getters.checkPermission("RESOURCES_D");
		},
	},
	methods: {
		editRecord() {
			this.$router.push(`/apps/resource/resource-edit/${this.params.data.id}`).catch(() => {});
		},
		confirmDeleteRecord() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: `${this.$t("Resource.List.CellRenderer.DeleteRecord")} "${this.params.data.username}"`,
				accept: this.deleteRecord,
				acceptText: this.$t("Crud.Delete"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteRecord() {
			this.$store
				.dispatch("moduleResource/removeResource", this.params.data.id)
				.then((res) => {
					this.showDeleteSuccess();
					return res;
				})
				.catch((err) => {
					throw new Error(err);
				});
		},
		showDeleteSuccess() {
			this.$vs.notify({
				color: "success",
				title: this.$t("Resource.List.CellRenderer.DeleteSuccess.Title"),
				text: this.$t("Resource.List.CellRenderer.DeleteSuccess.Text"),
			});
		},
	},
	created() {
		if (!moduleResource.isRegistered) {
			this.$store.registerModule("moduleResource", moduleResource);
			moduleResource.isRegistered = true;
		}
	},
};
</script>
